import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Footer } from "../../../components";

function Sign({ handleGlogin, handleManuallogin, handelChange, user }) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => setShowPassword((prev) => !prev);

  return (
    <div className="flex flex-col  min-h-screen ">
      <div className="px-6 py-12 flex flex-col w-full items-center justify-center">
        <div className="bg-white rounded-xl shadow-md border border-gray-200 max-w-md w-full p-4 px-8">
          <h1 className="text-2xl font-extrabold text-gray-900 text-center mb-4">
            Sign in to your account
          </h1>

          <form
            className="space-y-3"
            onSubmit={(e) => e.preventDefault()}
            aria-label="Sign in form">
            <button
              type="button"
              className="w-full flex justify-center items-center gap-3 border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 focus:ring-4 focus:ring-blue-300 font-semibold rounded-lg px-5 py-3 transition-colors duration-150"
              onClick={handleGlogin}
              aria-label="Sign in with Google">
              <FcGoogle size={26} />
              Sign in with Google
            </button>

            <div className="relative flex items-center my-4">
              <div className="flex-grow border-t border-gray-300"></div>
              <span className="mx-3 text-gray-400 text-sm font-medium">or</span>
              <div className="flex-grow border-t border-gray-300"></div>
            </div>

            <div>
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-semibold text-gray-700">
                Email address
              </label>
              <input
                id="email"
                type="email"
                name="email"
                value={user.email}
                onChange={handelChange}
                autoComplete="email"
                placeholder="you@example.com"
                className="w-full border border-gray-300 rounded-md p-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                required
              />
            </div>

            <div className="relative ">
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-semibold text-gray-700">
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={user.password}
                  onChange={handelChange}
                  placeholder="••••••••"
                  className="w-full border border-gray-300 rounded-md p-3 pr-10 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  required
                />
                <button
                  type="button"
                  onClick={togglePassword}
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                  aria-label={showPassword ? "Hide password" : "Show password"}>
                  {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                </button>
              </div>
            </div>

            <button
              type="button"
              className="w-full bg-primary text-white rounded-md py-3 font-semibold hover:bg-darkprimary focus:ring-4 focus:ring-lightprimary transition"
              onClick={handleManuallogin}>
              Sign In
            </button>

            <div className="flex flex-col sm:flex-row justify-between items-center text-sm mt-4 space-y-3 sm:space-y-0">
              <Link
                to="/forget"
                className="text-primary hover:underline font-medium">
                Forgot password?
              </Link>
              <p className="text-gray-600">
                Don’t have an account yet?{" "}
                <Link
                  to="/signup"
                  className="text-primary hover:underline font-medium">
                  Sign Up
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Sign;
